// Shared constants for the Planner component tree.
import { FileText, Calendar, Users, TrendingUp } from 'lucide-react';

export const ROLE_COLORS = {
  PM: '#8B5CF6', CS: '#0EA5E9', CF: '#F59E0B', IN: '#10B981',
  DM: '#EF4444', DE: '#6366F1', IF: '#64748B', UX: '#EC4899', TE: '#14B8A6',
  HC: '#D97706',
};

export const ROLE_BADGE_COLORS = {
  PM: 'bg-blue-100 text-blue-700', CS: 'bg-violet-100 text-violet-700',
  CF: 'bg-amber-100 text-amber-700', IF: 'bg-emerald-100 text-emerald-700',
  DM: 'bg-rose-100 text-rose-700', TR: 'bg-cyan-100 text-cyan-700',
  HC: 'bg-orange-100 text-orange-700',
};

export const CLIENT_COLORS = {
  project_sponsor: '#8B5CF6', client_pm: '#0EA5E9', sme: '#F59E0B',
  it_admin: '#10B981', change_champion: '#EC4899', data_owner: '#EF4444',
};

export const NARRATIVE_SECTIONS = [
  { key: 'executive_summary', title: 'Executive Summary', icon: FileText },
  { key: 'phase_timeline', title: 'Phase Timeline Overview', icon: Calendar },
  { key: 'staffing_analysis', title: 'Seertech Staffing Analysis', icon: Users },
  { key: 'client_resources_analysis', title: 'Client Resource Requirements', icon: Users },
  { key: 'risk_observations', title: 'Risk & Capacity Observations', icon: TrendingUp },
];
